module.exports = __webpack_public_path__ + "static/media/chess-board.c0f06769.svg";